/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The role of a user.
 */
export enum UserRole {
    TEAM_MEMBER = 'TEAM_MEMBER',
    OWNER = 'OWNER',
}
